define('modules/editor/models/brick_factory',['require','exports','module','base/class','./element_factory','./elements/area'],function(require, exports, module) {
  
  var Class = require("base/class"),
      ElementFactory = require("./element_factory"),
      Area = require("./elements/area");

  var Serialization = {
    fromJSON: function(json) {
      var model = module.exports.create(json.name, _.omit(json, "name", "x", "y"), {silenceNotify: true});
      _.each(model.propertyGroups, function(pg){
        pg.parent = model;
      });
      return model;
    }
  };

  // The only purpose of this class is to decouple Area Model from the rest of the element models
  module.exports = Class.extend(ElementFactory,{
      create: function(elementName, attrs, options) {
        return elementName === "element:area"? new Area.fromJSON(attrs, options) : ElementFactory.create.apply(ElementFactory, arguments);
      },
      fromJSON: Serialization.fromJSON
  });
});

